import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function KararsizlikTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['kararsizlik-testi']} />;
}
